import { useLocation } from 'react-router-dom';
import { isStorefrontPath } from '../utils/slugs';

/**
 * As ações da vitrine devem aparecer nesta tela?
 *
 * Hook, e não a condição repetida nos dois componentes de cabeçalho: eles
 * mostram o MESMO conjunto de ações em larguras diferentes, e duas cópias da
 * regra dariam um cabeçalho com sacola no desktop e sem ela no celular — ou o
 * contrário — no dia em que uma das duas mudasse.
 *
 * **Só o caminho decide.** Havia uma segunda metade — `experience ===
 * 'storefront'` — que existia porque a RAIZ não era a vitrine: ela era o
 * `RoleLanding`, e a preferência era o único jeito de saber onde a pessoa
 * estava. Com a vitrine ocupando a raiz, essa metade deixou de ajudar e passou
 * a atrapalhar: um admin com preferência "vitrine" veria a sacola em
 * `/operacao`, que não é vitrine nenhuma.
 */
export function useOnStorefront(): boolean {
  const { pathname } = useLocation();

  return isStorefrontPath(pathname);
}
